<template>
  <div class="bg-bordered">

  <el-row type="flex" align="middle" justify="center">

    <el-col v-if="localStats.tickets > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.tickets" icon="fa fa-headset" caption="All" color="slateblue" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets" />
    </el-col>
    <el-col v-if="localStats.ticketPending > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketPending" icon="fa fa-random" caption="Pending" color="goldenrod" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/pending" />
    </el-col>
    <el-col v-if="localStats.ticketReview > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketReview" icon="fa fa-eye" caption="Review" color="indianred" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/review" />
    </el-col>
    <el-col v-if="localStats.ticketOpen > 0" align="center"  :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" >
      <dash-text :value="localStats.ticketOpen" icon="fa fa-folder-open" caption="Open" color="slategrey" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/open" />
    </el-col>
    <el-col v-if="localStats.active > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.active" icon="fa fa-tasks" caption="Active" color="navy" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/active" />
    </el-col>
    <el-col v-if="localStats.ticketOverdue > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketOverdue" icon="fa fa-hourglass-end" caption="Overdue" color="orange" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/overdue" />
    </el-col>
    <el-col v-if="localStats.ticketUrgent > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketUrgent" background="antique white" icon="fa fa-chevron-up" caption="Urgent" color="orange" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/null/urgent" />
    </el-col>
    <el-col v-if="localStats.ticketCritical > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketCritical" background="antique white" icon="fa fa-asterisk" caption="Critical" color="indianred" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/null/critical" />
    </el-col>
    <el-col v-if="localStats.ticketClosed > 0" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
      <dash-text :value="localStats.ticketClosed" icon="fa fa-folder" caption="Closed" no-plural :size="iconSize" :caption-size="height" :align="pos" url="/tickets/completed-closed"  />
    </el-col>

  </el-row>

</div>
</template>

<script>

import DashText from '@/components/atoms/DashText'

export default {

  components: {
    DashText
  },

  data () {

    return {
      media: {xs: 24, sm: 12, md: 6, lg: 3},
      pos: 'center',
      iconSize: '1.5em',
      height: '0.8em',
      status: null,
      priority: null,
      localStats: this.getStats()
    }

  }

}
</script>



// WEBPACK FOOTER //
// TicketStats.vue?2a4d2e46